import { combineReducers } from 'redux';

import isReady from './isReady';
import sessionId from './sessionId';
import title from './title';
import userId from './userId';

const app = combineReducers({
  isReady,
  sessionId,
  title,
  userId,
});

export default app;



// WEBPACK FOOTER //
// ./src/reducers/app/index.js